import { render } from "./post-smtp-banners.vue?vue&type=template&id=b0a24b2e&scoped=true"
import script from "./post-smtp-banners.vue?vue&type=script&lang=js"
export * from "./post-smtp-banners.vue?vue&type=script&lang=js"

import "./post-smtp-banners.vue?vue&type=style&index=0&id=b0a24b2e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0a24b2e"]])

export default __exports__